import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      flex-shrink: 0;\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: transparent;\n  flex-grow: 1;\n  width: 100%;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { isDefined } from '../../helpers/defined';
import { pointerEventsNoneStyle } from '../../tokens/pointer-events';
import { width } from '../../style/width';
var FormContainer = styled.div(_templateObject(), function (_ref) {
  var $width = _ref.$width;
  return isDefined($width) && css(_templateObject2(), width($width));
}, function (_ref2) {
  var $inactive = _ref2.$inactive;
  return (// Makes everything inside not touchable/clickable
    $inactive && "\n      & * {\n        " + pointerEventsNoneStyle + "\n      }\n    "
  );
});
export default FormContainer;